import Binance from "binance-api-node";
import { retrieveMarketCapData } from "./retrieveMarketCapData";
const BinanceClient = Binance();

const fillInMarketData = (dataArray) => {
  return dataArray.symbols.map(({ symbol }) => {
    let marketCap = retrieveMarketCapData(symbol);
    return {
      name: symbol,
      id: symbol,
      marketCap,
    };
  });
};

export const getBinanceChartList = async () => {
  const exchangeData = await BinanceClient.exchangeInfo();
  const populatedData = fillInMarketData(exchangeData);
  return populatedData;
};
